import { AxiosResponse } from 'axios';
import {
  SET_KNOWLEDGE_BASE_CATEGORIES,
  SET_KNOWLEDGE_BASE_CATEGORY,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  CLEAR_KNOWLEDGE_BASE_CATEGORY_ISLOADING,
  DELETE_KNOWLEDGE_BASE_CATEGORY,
  EDIT_KNOWLEDGE_BASE_CATEGORY,
  GET_KNOWLEDGE_BASE_CATEGORIES,
  GET_KNOWLEDGE_BASE_CATEGORY,
  REGISTER_KNOWLEDGE_BASE_CATEGORY,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import KnowledgeBaseCategory from '@/services/knowledge_base_category';
import { Module } from 'vuex';
import {
  EditKnowledgeBaseCategory,
  RegisterKnowledgeBaseCategory,
  GetKnowledgeBaseCategory,
} from '@/dtos/knowledge_base_category.dto';

const knowledgeBaseCategory: Module<any, {}> = {
  state: {
    knowledgeBaseCategory: {
      data: null,
      isLoading: false,
    },
    knowledgeBaseCategories: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    knowledgeBaseCategory: (state: { knowledgeBaseCategory: any }) => state.knowledgeBaseCategory,
    knowledgeBaseCategories: (state: { knowledgeBaseCategories: any }) => state.knowledgeBaseCategories,
  },
  mutations: {
    [SET_KNOWLEDGE_BASE_CATEGORY]: (
      state: { knowledgeBaseCategory: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.knowledgeBaseCategory.data = payload.data) : null,
        (state.knowledgeBaseCategory.isLoading = payload.isLoading);
    },
    [SET_KNOWLEDGE_BASE_CATEGORIES]: (
      state: { knowledgeBaseCategories: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.knowledgeBaseCategories.data = payload.data) : null,
        (state.knowledgeBaseCategories.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_KNOWLEDGE_BASE_CATEGORY]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseCategory.registerKnowledgeBaseCategory(
        payload as RegisterKnowledgeBaseCategory
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { isLoading: false });
        return false;
      }
    },
    [GET_KNOWLEDGE_BASE_CATEGORIES]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_CATEGORIES, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseCategory.getKnowledgeBaseCategories(
        payload as GetKnowledgeBaseCategory
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_CATEGORIES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_CATEGORIES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_CATEGORIES, { isLoading: false });
        return false;
      }
    },
    [GET_KNOWLEDGE_BASE_CATEGORY]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseCategory.getKnowledgeBaseCategories(
        payload as GetKnowledgeBaseCategory
      );

      if (result) {
        if (result.data.status) {
          const data = Array.isArray(result.data.data) ? result.data.data[0] : result.data.data;
          commit(SET_KNOWLEDGE_BASE_CATEGORY, { data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { isLoading: false });
        return false;
      }
    },
    [EDIT_KNOWLEDGE_BASE_CATEGORY]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseCategory.editKnowledgeBaseCategory(
        payload as EditKnowledgeBaseCategory
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { isLoading: false });
        return false;
      }
    },
    [DELETE_KNOWLEDGE_BASE_CATEGORY]: async ({ commit }: any, payload: string) => {
      commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseCategory.deleteKnowledgeBaseCategory(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_CATEGORY, { isLoading: false });
        return false;
      }
    },
    [CLEAR_KNOWLEDGE_BASE_CATEGORY_ISLOADING]: ({ commit }) => {
      commit(SET_KNOWLEDGE_BASE_CATEGORY, { isLoading: false });
      commit(SET_KNOWLEDGE_BASE_CATEGORIES, { isLoading: false });
    },
  },
};

export default knowledgeBaseCategory;
